import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-182d60bd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "Shortcuts__Wrapper",
  "data-fixed": ""
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 40 40" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-shortcut-dashboard" })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 40 40" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-shortcut-courses" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "shortcuts",
      duration: 1500
    }, {
      default: _withCtx(() => [
        (_ctx.isMounted)
          ? (_openBlock(), _createElementBlock("nav", {
              key: 0,
              class: _normalizeClass({ 'Shortcuts': true, 'is-hidden': this.hidden })
            }, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/dashboard" }, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('course.dashboard')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/courses" }, {
                    default: _withCtx(() => [
                      _hoisted_3,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('course.courses')), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}